<template>
    <div>
        <div v-show="files.length > 0" class="container-fluid" style="padding: 0; margin-bottom: .5rem;">
            <div class="row" style="padding: 0.5rem 1rem;" v-for="file in files">
                <div class="col" style="padding: 0;">
                    <ui-icon icon-set="material-icons-outlined" style="margin-right: .5rem;">description</ui-icon>
                    {{ file.filename }} <strong>({{ file.size | humanBytes }})</strong>
                </div>
                <div class="col-2 text-right" style="padding: 0;">
                    <ui-icon-button @click="removeFile(file)" icon="clear" type="secondary" size="mini" color="red"></ui-icon-button>
                </div>
            </div>
        </div>
        <secondary-pill-button @click="pickAttachment">
            <ui-icon style="font-size: 1rem;">attach_file</ui-icon>
            Add Attachment
        </secondary-pill-button>
        <document-picker-modal ref="documentPicker" @selected="filesSelected"></document-picker-modal>
    </div>
</template>

<script>
import DocumentPickerModal from "../elements/DocumentPickerModal"
import Filters from '../../filters'

export default {
    filters: Filters,
    components: {DocumentPickerModal},
    props: {
        value: {
            type: Array,
            default() {
                return []
            }
        }
    },
    created() {
        this.files = this.value
    },
    data() {
        return {
            files: []
        }
    },
    methods: {
        filesSelected(files) {
            this.files = this.files.concat(files)

            this.triggerUpdate()
        },
        pickAttachment() {
            this.$refs.documentPicker.open()
        },
        removeFile(file) {
            this.files = this.files.filter(f => f !== file)

            this.triggerUpdate()
        },
        triggerUpdate() {
            this.$emit('input', this.files)
        }
    }
}
</script>

<style scoped>

</style>